var map = {
	"./chat_bubble/chat_bubble.tsx": 3610,
	"./context_renderer/__tests__/context_renderer.test.tsx": 75428,
	"./context_renderer/context_renderer.tsx": 66294,
	"./coupon_items/coupon_bubble/coupon_bubble.tsx": 69956,
	"./coupon_items/coupon_label/coupon_label.tsx": 81324,
	"./mbw_colors/ka/mbw_colors.tsx": 45601,
	"./mbw_colors/pg/mbw_colors.tsx": 12984,
	"./mbw_colors/ps/mbw_colors.tsx": 39764,
	"./my_orders_order_cell/my_orders_order_cell.tsx": 41860
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7882;